import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Response } from '@angular/http';
import { Observable } from 'rxjs';
import { AppSettings } from '../common/app.settings';
import 'rxjs/add/operator/map';
import { Question } from '../models/question.model';
import { FileImportModel } from '../models/file.import.model';
import { ApiResult } from '../models/apiresult.model';
import { ContentHeaders } from '../common/headers';
import { Locations } from '../models/locations.model';

@Injectable()
export class QuestionService {
    private apiController = '/Question';

    constructor(
        private http: Http,
        private contentHeaders: ContentHeaders) {
    }

    getQuestions(questionGroupId: string): Promise<Question[]> {
        // get users from api
        return this.http.get(AppSettings.apiEndPoint + this.apiController + '/GetQuestions/' + questionGroupId, { headers: this.contentHeaders.headers })
            .map((response: Response) => {
                return response.json();
            })
            .toPromise()
            .catch(this.handleErrorPromise);
    }

    exportQuestions(questionGroupId: string): Promise<any> {
        // get users from api
        return this.http.get(AppSettings.apiEndPoint + this.apiController + '/ExportQuestions/' + questionGroupId, { headers: this.contentHeaders.headers })
            .map((response: Response) => {
                var blob = new Blob([(<any>response)._body], { type: 'application/json' });
                return blob;
            })
            .toPromise()
            .catch(this.handleErrorPromise);
    }

    getQuestion(questionId: string): Promise<Question> {
        return this.http.get(
            AppSettings.apiEndPoint + this.apiController + '/' + questionId,
            { headers: this.contentHeaders.headers }
            )
            .map((response: Response) => response.json())
            .toPromise()
            .catch(this.handleErrorPromise);
    }

    updateQuestion(question: Question): Promise<ApiResult> {
        return this.http.put(
            AppSettings.apiEndPoint + this.apiController + '/' + question.id,
                JSON.stringify(question),
                { headers: this.contentHeaders.headers }
            )
            .map((response: Response) => response.json())
            .toPromise()
            .catch(this.handleErrorPromise);
    }

    addQuestion(question: Question): Promise<ApiResult> {
        return this.http.post(
            AppSettings.apiEndPoint + this.apiController + '/',
                JSON.stringify(question),
                { headers: this.contentHeaders.headers }
            )
            .map((response: Response) => response.json())
            .toPromise()
            .catch(this.handleErrorPromise);
    }

    deleteQuestion(questionId: string): Promise<ApiResult> {
        return this.http.delete(
            AppSettings.apiEndPoint + this.apiController + '/' + questionId,
            { headers: this.contentHeaders.headers }
            )
            .map((response: Response) => response.json())
            .toPromise()
            .catch(this.handleErrorPromise);
    }

    importImage(formData: FormData, questionGroupId: string): Promise<ApiResult> {
        return this.http.post(
            AppSettings.apiEndPoint + this.apiController + '/ImportImage/' + questionGroupId,
                formData,
                { headers: this.contentHeaders.headersWithoutContentType() }
            )
            .map((response: Response) => response.json())
            .toPromise()
            .catch(this.handleErrorPromise);
    }

    removeProfile(questionId: string): Promise<ApiResult> {
        return this.http.get(
            AppSettings.apiEndPoint + this.apiController + '/StripImage/' + questionId,
            { headers: this.contentHeaders.headers }
            )
            .map((response: Response) => response.json())
            .toPromise()
            .catch(this.handleErrorPromise);
    }

    rotateImage(questionId: string): Promise<ApiResult> {
        return this.http.get(
            AppSettings.apiEndPoint + this.apiController + '/RotateImage/' + questionId,
            { headers: this.contentHeaders.headers }
            )
            .map((response: Response) => response.json())
            .toPromise()
            .catch(this.handleErrorPromise);
    }

    private handleErrorPromise(error: any): Promise<void> {
        try {
            error = JSON.parse(error._body);
        } catch (e) {
        }

        const errMsg = error.errorMessage
            ? error.errorMessage
            : error.message
            ? error.message
            : error._body
            ? error._body
            : error.status
            ? `${error.status} - ${error.statusText}`
            : 'unknown server error';

        console.error(errMsg);
        return Promise.reject(errMsg);
    }
}



// WEBPACK FOOTER //
// ./src/app/services/question.service.ts